import { render, staticRenderFns } from "./WalletTransactionReport.vue?vue&type=template&id=09136420"
import script from "./WalletTransactionReport.vue?vue&type=script&lang=js"
export * from "./WalletTransactionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports